<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">
			门店管理>{{activeName=="one"?"门店管理":""}}{{activeName=="two"?"加盟管理":""}}{{activeName=="three"?"门店指示":""}}</div>
		<el-tabs type="border-card" v-model="activeName">
			<el-tab-pane name="one" label="门店管理">
				<list1 v-if="activeName=='one'"></list1>
			</el-tab-pane>
			<el-tab-pane name="three" label="业绩设置">
				<list3 v-if="activeName=='three'"></list3>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
	import list1 from "./storelist/storelist1.vue"
	// import list2 from "./storelist/storelist2.vue"
	import list3 from "./storelist/storelist3.vue"
	export default {
		components: {
			list1,
			// list2,
			list3,
		},
		data() {
			return {
				activeName: "one"
			};
		},
		mounted() {
			if (this.$route.query.id == 1) {
				this.activeName = "one"
			}
			if (this.$route.query.id == 2) {
				this.activeName = "two"
			}
			if (this.$route.query.id == 3) {
				this.activeName = "three"
			}
		},
		methods: {
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
		},
	};
</script>
<style lang="less" scoped>
</style>